export default __webpack_public_path__ + "assets/images/71162906ea556b3b1775e948202c0a3b-beware_of_the_origin.svg";